module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-build-issue-48.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/vux-build-issue.md
// module id = 749
// module chunks = 200